import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";

export function MembersPageSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      {/* Header Section - matches ListLayout */}
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-8 w-40" />
          <Skeleton className="h-4 w-96" />
        </div>
        <Skeleton className="h-9 w-36" />
      </div>

      {/* Content */}
      <div className="grid items-start gap-6 xl:grid-cols-2">
        {/* Members Section */}
        <section className="rounded-xl border bg-card/50 p-4">
          <div className="mb-4 flex items-start gap-3">
            <Skeleton className="h-9 w-9 shrink-0 rounded-lg" />
            <div>
              <Skeleton className="h-5 w-28" />
              <Skeleton className="mt-1.5 h-4 w-48" />
            </div>
          </div>
          {/* Toolbar skeleton */}
          <div className="mb-4 flex items-center justify-between gap-2">
            <Skeleton className="h-8 w-[200px]" />
            <Skeleton className="h-8 w-[80px]" />
          </div>
          {/* Table skeleton */}
          <div className="overflow-hidden rounded-lg border">
            <div className="bg-muted/50 px-4 py-3">
              <div className="flex gap-8">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-4 w-32" />
              </div>
            </div>
            <div className="divide-y">
              {[1, 2, 3].map((i) => (
                <div className="flex items-center gap-4 px-4 py-3" key={i}>
                  <Skeleton className="h-8 w-8 rounded-full" />
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-4 w-48" />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pending Invitations Section */}
        <section className="rounded-xl border bg-card/50 p-4">
          <div className="mb-4 flex items-start gap-3">
            <Skeleton className="h-9 w-9 shrink-0 rounded-lg" />
            <div>
              <Skeleton className="h-5 w-44" />
              <Skeleton className="mt-1.5 h-4 w-52" />
            </div>
          </div>
          {/* Toolbar skeleton */}
          <div className="mb-4 flex items-center justify-between gap-2">
            <Skeleton className="h-8 w-[200px]" />
            <Skeleton className="h-8 w-[80px]" />
          </div>
          {/* Table skeleton */}
          <div className="overflow-hidden rounded-lg border">
            <div className="bg-muted/50 px-4 py-3">
              <div className="flex gap-8">
                <Skeleton className="h-4 w-16" />
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-20" />
              </div>
            </div>
            <div className="divide-y">
              {[1, 2].map((i) => (
                <div className="flex items-center gap-4 px-4 py-3" key={i}>
                  <div className="flex-1 space-y-1.5">
                    <Skeleton className="h-4 w-40" />
                    <Skeleton className="h-3 w-32" />
                  </div>
                  <Skeleton className="h-8 w-20" />
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
